export default __webpack_public_path__ + "static/media/default-user-avatar.c0d881cc.svg";